export default function isDicomUid(subject: unknown) {
	const regex = /^\d+(?:\.\d+)*$/;
	return typeof subject === 'string' && regex.test(subject.trim());
}
